import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useConsent } from '../contexts/ConsentContext';
import { Capacitor } from '@capacitor/core';
import ProMarketingLink from './Marketing/ProMarketingLink';
import './CookieConsentBanner.css';

const privacyLinkComponents = {
  privacyLink: (
    <ProMarketingLink to="/privacy-policy" target="_blank" rel="noopener noreferrer" />
  ),
};

export const CookieConsentBanner: React.FC = () => {
  const { t } = useTranslation('legal');
  const { isDecided, grantConsent, denyConsent } = useConsent();

  // Ne pas afficher sur iOS natif (PostHog désactivé)
  const isNativeIOS = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
  if (isNativeIOS || isDecided) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label={t('cookieConsentBanner.ariaLabel')}>
      <div className="cookie-banner__bg" />
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <Trans
            i18nKey="cookieConsentBanner.text"
            ns="legal"
            components={privacyLinkComponents}
          />
        </div>
        <div className="cookie-banner__buttons">
          <button className="cookie-btn cookie-btn--decline" onClick={denyConsent}>
            {t('cookieConsentBanner.declineAll')}
          </button>
          <button className="cookie-btn cookie-btn--accept" onClick={grantConsent}>
            {t('cookieConsentBanner.acceptAll')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
